import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';

const PANEL_OVERLAY_ALPHA = 191 / 255;

export const cameraMenuDropdownPaperSx: SxProps<Theme> = (theme) => ({
  mt: 0.5,
  minWidth: 100,
  width: 'max-content',
  maxWidth: 'min(100vw - 24px, 280px)',
  position: 'relative',
  overflow: 'visible',
  borderRadius: '4px',
  bgcolor: alpha(theme.palette.common.black, PANEL_OVERLAY_ALPHA),
  backdropFilter: 'blur(10px)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 8,
    width: 12,
    height: 7,
    bgcolor: alpha(theme.palette.common.black, PANEL_OVERLAY_ALPHA),
    clipPath: 'polygon(50% 0, 0 100%, 100% 100%)',
    transform: 'translateY(-100%)',
    pointerEvents: 'none',
  },
});

export const cameraMenuDropdownCaptionSx: SxProps<Theme> = (theme) => ({
  color: alpha(theme.palette.common.white, 0.72),
  display: 'block',
});

export const cameraMenuDropdownMenuItemSx: SxProps<Theme> = (theme) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '10px',
  gap: 1,
  color: 'common.white',
  '&:hover': { bgcolor: alpha(theme.palette.common.white, 0.08) },
  '&.Mui-selected': { bgcolor: 'transparent' },
  '&.Mui-selected:hover': { bgcolor: alpha(theme.palette.common.white, 0.16) },
  '&.Mui-disabled': { color: alpha(theme.palette.common.white, 0.38) },
});
